import { useContext } from 'react';
import ODAS from '@/utils/api/odas';
import { AccountContext } from '@/context/account.context';

const DEBUG = typeof window !== 'undefined' && window.location.hostname === 'localhost';

const useLog = () => {
  const account = useContext(AccountContext);

  const log = (params) => {
    if (account.state.isLoggedIn && account.trackUser()) {
      if (DEBUG) console.log('** logging', params);
      return ODAS.post('/api/logs', { activity_log: params });
    } else {
      return Promise.resolve();
    }
  };

  const reportError = (msg, details) => {
    details = details || {};
    return ODAS.post('/api/logs/error', { msg, details });
  };

  return {
    log: log,
    reportError: reportError
  };
};

export default useLog;
